export default __webpack_public_path__ + "static/media/beach.04849e85.svg";